import { AudienceSyncTimeBasedSchedule } from '@/models/audiences';
import { FC } from 'react';
import { AudienceSyncRepeatNext } from './AudienceSyncRepeatNext';
import { AudienceSyncRepeatStart } from './AudienceSyncRepeatStart';
import { AudienceSyncRepeatUnit } from './AudienceSyncRepeatUnit';

type AudienceSyncRepeatConfigProps = {
  scheduleConfiguration: AudienceSyncTimeBasedSchedule;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
};

export const AudienceSyncRepeatConfig: FC<AudienceSyncRepeatConfigProps> = ({ scheduleConfiguration, setFieldValue }) => {
  return (
    <div className='p-6'>
      <AudienceSyncRepeatStart scheduleConfiguration={scheduleConfiguration} setFieldValue={setFieldValue} />
      <AudienceSyncRepeatUnit scheduleConfiguration={scheduleConfiguration} setFieldValue={setFieldValue} />
      <AudienceSyncRepeatNext scheduleConfiguration={scheduleConfiguration} />
    </div>
  );
};
